import { PropsWithChildren } from 'react'

export function Container({ children }: PropsWithChildren) {
  return (
    <div className="pointer-events-none fixed bottom-spacing0 left-spacing0 right-spacing0 flex items-center justify-center">
      {children}
    </div>
  )
}
